<div class="courses">
  <div class="header">
    <h2>Courses</h2>
    <div class="actions">
      <button type="button" class="btn btn--ghost btn--icon-left" (click)="openVideoLibrary()">
        <span class="icon">▶</span> Videos
      </button>
      <button type="button" class="btn btn--success btn--lg btn--icon-left" (click)="startCreate()">
        <span class="icon">＋</span> New Course
      </button>
      <button type="button" class="btn btn--outline btn--icon-left" (click)="loadCourses()">
        <span class="icon">⟳</span> Refresh
      </button>
    </div>
  </div>

  <div class="card">
    <div class="card__header">Courses</div>
    <div class="card__content">
      <div class="status" *ngIf="loading()">Loading…</div>
      <div class="error" *ngIf="errorText()">
        {{ errorText() }}
        <button type="button" class="error__close" (click)="dismissError()">×</button>
      </div>

      <ng-container *ngIf="!loading()">
        <div class="muted" *ngIf="courses().length === 0">No courses found.</div>
        <table class="table" *ngIf="courses().length > 0">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Type</th>
              <th>Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of courses(); trackBy: trackByCourseId">
              <td>{{ c.COURSE_ID }}</td>
              <td>{{ c.COURSE_NAME }}</td>
              <td>{{ c.TYPE || '—' }}</td>
              <td>{{ c.ADDED_ON }}</td>
              <td class="actions">
                <button type="button" class="btn btn--sm" (click)="viewCourse(c)">View</button>
                <button type="button" class="btn btn--sm" (click)="startEdit(c)">Edit</button>
                <button type="button" class="btn btn--sm btn--danger" (click)="deleteCourse(c)">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>

  <!-- View Dialog -->
  <div class="dialog-overlay" *ngIf="viewOpen() && selected() as s" (click)="closeViewDialog()">
    <div class="dialog" (click)="$event.stopPropagation()">
      <div class="dialog__header">
        <div class="dialog__title">View Course</div>
        <button type="button" class="dialog__close" (click)="closeViewDialog()">×</button>
      </div>
      <div class="dialog__content">
        <div class="meta">
          <div><strong>Name:</strong> {{ s.COURSE_NAME }}</div>
          <div><strong>ID:</strong> {{ s.COURSE_ID }}</div>
          <div><strong>Type:</strong> {{ s.TYPE || '—' }}</div>
          <div><strong>Added:</strong> {{ s.ADDED_ON }}</div>
          <div><strong>Modified:</strong> {{ s.MODIFIED_ON }}</div>
        </div>
        <h3>Content</h3>
        <div class="muted" *ngIf="!s.CONTENT?.length">No content items.</div>
        <table class="table" *ngIf="s.CONTENT?.length">
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Key</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of s.CONTENT">
              <td>{{ item.SNO }}</td>
              <td>{{ item.CONTENT_TYPE }}</td>
              <td>
                <ng-container [ngSwitch]="item.CONTENT_TYPE">
                  <ng-container *ngSwitchCase="'VIDEO'">
                    <ng-container *ngIf="videoExistsKey(item.KEY); else missingLibVideo">
                      <a href="#" (click)="$event.preventDefault(); openVideoKey(item.KEY)" target="_blank" rel="noopener">{{ item.KEY }}</a>
                    </ng-container>
                    <ng-template #missingLibVideo>
                      <em>{{ item.KEY }} (video no longer exists)</em>
                    </ng-template>
                  </ng-container>
                  <a *ngSwitchCase="'DOCUMENT'" [href]="item.KEY" target="_blank" rel="noopener">{{ item.KEY }}</a>
                  <ng-container *ngSwitchDefault>{{ item.KEY }}</ng-container>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="dialog__footer">
        <button type="button" class="btn" (click)="closeViewDialog()">Close</button>
      </div>
    </div>
  </div>

  <!-- Edit Dialog -->
  <div class="dialog-overlay" *ngIf="editOpen() && selected()">
    <div class="dialog" (click)="$event.stopPropagation()">
      <div class="dialog__header">
        <div class="dialog__title">Edit Course</div>
        <button type="button" class="dialog__close" (click)="closeEditDialog()">×</button>
      </div>
      <div class="dialog__content">
        <form [formGroup]="form" (ngSubmit)="submitUpdate()" novalidate>
          <div class="form-row">
            <label for="COURSE_NAME_EDIT">Course Name <span class="req">*</span></label>
            <input id="COURSE_NAME_EDIT" type="text" formControlName="COURSE_NAME" required />
            <div class="field-error" *ngIf="form.get('COURSE_NAME')?.touched && form.get('COURSE_NAME')?.invalid">
              Name is required.
            </div>
          </div>

          <div class="content-list">
            <div class="content-list__header">
              <h3>Content Items</h3>
              <button type="button" class="btn btn--sm" (click)="addContentRow()">Add Item</button>
            </div>

            <div class="content-row" *ngFor="let group of contentArray.controls; let i = index" [formGroup]="group">
              <div class="form-row form-row--inline">
                <label># <span class="req">*</span></label>
                <input type="text" formControlName="SNO" class="w-80" required />
                <div class="field-error" *ngIf="group.get('SNO')?.touched && group.get('SNO')?.invalid">
                  Required.
                </div>
              </div>
              <div class="form-row form-row--inline">
                <label>Type <span class="req">*</span></label>
                <select formControlName="CONTENT_TYPE" class="w-140" required>
                  <option [ngValue]="''" disabled>Please select…</option>
                  <option value="VIDEO">VIDEO</option>
                  <option value="DOCUMENT">DOCUMENT</option>
                </select>
                <div class="field-error" *ngIf="group.get('CONTENT_TYPE')?.touched && group.get('CONTENT_TYPE')?.invalid">
                  Required.
                </div>
              </div>
            <div class="form-row form-row--inline grow">
              <label>Key <span class="req">*</span></label>
              <ng-container [ngSwitch]="group.get('CONTENT_TYPE')?.value">
                <select *ngSwitchCase="'VIDEO'" formControlName="KEY" required>
                  <option [ngValue]="''" disabled>Select a video…</option>
                  <option *ngFor="let v of videos()" [ngValue]="v.key">{{ v.key }}</option>
                </select>
                <input *ngSwitchDefault type="text" formControlName="KEY" required />
              </ng-container>
              <div class="field-error" *ngIf="group.get('KEY')?.touched && group.get('KEY')?.invalid">
                Required.
              </div>
            </div>
              <button type="button" class="icon-btn remove-btn" (click)="removeContentRow(i)" aria-label="Remove item">×</button>
            </div>
          </div>

          <div class="dialog__footer">
            <button type="submit" class="btn btn--primary">Update</button>
            <button type="button" class="btn" (click)="closeEditDialog()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Create Dialog -->
  <div class="dialog-overlay" *ngIf="createOpen()">
    <div class="dialog" (click)="$event.stopPropagation()">
      <div class="dialog__header">
        <div class="dialog__title">New Course</div>
        <button type="button" class="dialog__close" (click)="closeCreateDialog()">×</button>
      </div>
      <div class="dialog__content">
        <form [formGroup]="form" (ngSubmit)="submitCreate()" novalidate>
          <div class="form-row">
            <label for="COURSE_NAME_CREATE">Course Name <span class="req">*</span></label>
            <input id="COURSE_NAME_CREATE" type="text" formControlName="COURSE_NAME" required />
            <div class="field-error" *ngIf="form.get('COURSE_NAME')?.touched && form.get('COURSE_NAME')?.invalid">
              Name is required.
            </div>
          </div>

          <div class="content-list">
            <div class="content-list__header">
              <h3>Content Items</h3>
              <button type="button" class="btn btn--sm" (click)="addContentRow()">Add Item</button>
            </div>

            <div class="content-row" *ngFor="let group of contentArray.controls; let i = index" [formGroup]="group">
              <div class="form-row form-row--inline">
                <label># <span class="req">*</span></label>
                <input type="text" formControlName="SNO" class="w-80" required />
                <div class="field-error" *ngIf="group.get('SNO')?.touched && group.get('SNO')?.invalid">
                  Required.
                </div>
              </div>
              <div class="form-row form-row--inline">
                <label>Type <span class="req">*</span></label>
                <select formControlName="CONTENT_TYPE" class="w-140" required>
                  <option [ngValue]="''" disabled>Please select…</option>
                  <option value="VIDEO">VIDEO</option>
                  <option value="DOCUMENT">DOCUMENT</option>
                </select>
                <div class="field-error" *ngIf="group.get('CONTENT_TYPE')?.touched && group.get('CONTENT_TYPE')?.invalid">
                  Required.
                </div>
              </div>
              <div class="form-row form-row--inline grow">
                <label>Key <span class="req">*</span></label>
                <ng-container [ngSwitch]="group.get('CONTENT_TYPE')?.value">
                  <select *ngSwitchCase="'VIDEO'" formControlName="KEY" required>
                    <option [ngValue]="''" disabled>Select a video…</option>
                    <option *ngFor="let v of videos()" [ngValue]="v.key">{{ v.key }}</option>
                  </select>
                  <input *ngSwitchDefault type="text" formControlName="KEY" required />
                </ng-container>
                <div class="field-error" *ngIf="group.get('KEY')?.touched && group.get('KEY')?.invalid">
                  Required.
                </div>
              </div>
              <button type="button" class="icon-btn remove-btn" (click)="removeContentRow(i)" aria-label="Remove item">×</button>
            </div>
          </div>

          <div class="dialog__footer">
            <button type="submit" class="btn btn--primary">Create</button>
            <button type="button" class="btn" (click)="closeCreateDialog()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Video Library Dialog -->
  <div class="dialog-overlay" *ngIf="videoOpen()">
    <div class="dialog" (click)="$event.stopPropagation()">
      <div class="dialog__header">
        <div class="dialog__title">Video Library</div>
        <button type="button" class="dialog__close" (click)="closeVideoLibrary()" [disabled]="videoLoading()">×</button>
      </div>
      <div class="dialog__content">

        <div class="status" *ngIf="videoLoading()">Loading…</div>
        <div class="error" *ngIf="videoError()">
          {{ videoError() }}
          <button type="button" class="error__close" (click)="dismissVideoError()">×</button>
        </div>

        <div class="upload-new">
          <h3>Upload New Video</h3>
          <div class="upload-row">
            <div class="form-row form-row--inline grow">
              <label>Key (optional; defaults to filename)</label>
              <input #newKey type="text" placeholder="path/to/video.mp4" />
            </div>
            <div class="form-row form-row--inline">
              <input #newFile type="file" accept="video/*" (change)="prefillKeyFromFile(newFile, newKey)" [disabled]="videoLoading()" />
            </div>
            <div class="form-row form-row--inline">
              <button type="button" class="btn btn--primary" (click)="uploadNewVideoFromFile(newFile, newKey)" [disabled]="videoLoading() || !newFile.files?.length">Upload</button>
            </div>
          </div>
        </div>

        <h3 style="margin-top: 16px;">Videos</h3>
        <div class="muted" *ngIf="!videoLoading() && videos().length === 0">No videos found.</div>
        <table class="table table--full" *ngIf="videos().length > 0">
          <thead>
            <tr>
              <th class="col-key">Key</th>
              <th class="col-size">Size</th>
              <th class="col-date">Last Modified</th>
              <th class="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of videos()">
              <td class="wrap col-key">{{ v.key }}</td>
              <td class="col-size">{{ formatSize(v.size) }}</td>
              <td class="col-date">{{ v.last_modified }}</td>
              <td class="actions col-actions">
                <label class="btn btn--sm" [class.btn--disabled]="videoLoading()">
                  Replace
                  <input #replFile type="file" accept="video/*" style="display:none" (change)="replaceVideoFromFile(v.key, replFile)" [disabled]="videoLoading()" />
                </label>
                <button type="button" class="btn btn--sm btn--danger" (click)="deleteVideo(v.key)" [disabled]="videoLoading()">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="dialog__footer">
        <button type="button" class="btn" (click)="closeVideoLibrary()" [disabled]="videoLoading()">Close</button>
      </div>

      <!-- Busy overlay to block interaction while uploading/replacing/deleting -->
      <div class="busy-overlay" *ngIf="videoLoading()">
        <div class="busy-overlay__content">
          <div class="spinner" aria-hidden="true"></div>
          <div class="busy-text">Please wait…</div>
        </div>
      </div>
    </div>
  </div>
</div>


